// DO NOT EDIT -- generated from fs/services/emissary/shopify.proto

import * as protobuf from '../../../google/protobuf';

export namespace Shopify {

  export const GetShopifyStoreEndpoint = "/grpc/emissary.Shopify/GetShopifyStore";
  export function GetShopifyStore(sender: (req: GetShopifyStoreRequest, endpoint: string) => Promise<GetShopifyStoreResponse>, req: GetShopifyStoreRequest): { promise: () => Promise<GetShopifyStoreResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetShopifyStoreEndpoint),
      endpoint: GetShopifyStoreEndpoint
    };
  }

  export const GetShopifyStoresWithUserRedactIdsEndpoint = "/grpc/emissary.Shopify/GetShopifyStoresWithUserRedactIds";
  export function GetShopifyStoresWithUserRedactIds(sender: (req: {}, endpoint: string) => Promise<GetShopifyStoresWithUserRedactIdsResponse>, req: {}): { promise: () => Promise<GetShopifyStoresWithUserRedactIdsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetShopifyStoresWithUserRedactIdsEndpoint),
      endpoint: GetShopifyStoresWithUserRedactIdsEndpoint
    };
  }

  export const AddSegmentIdToShopifyStoreEndpoint = "/grpc/emissary.Shopify/AddSegmentIdToShopifyStore";
  export function AddSegmentIdToShopifyStore(sender: (req: AddSegmentIdToShopifyStoreRequest, endpoint: string) => Promise<AddSegmentIdToShopifyStoreResponse>, req: AddSegmentIdToShopifyStoreRequest): { promise: () => Promise<AddSegmentIdToShopifyStoreResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AddSegmentIdToShopifyStoreEndpoint),
      endpoint: AddSegmentIdToShopifyStoreEndpoint
    };
  }

  export const AddUserRedactIdsToShopifyStoreEndpoint = "/grpc/emissary.Shopify/AddUserRedactIdsToShopifyStore";
  export function AddUserRedactIdsToShopifyStore(sender: (req: AddUserRedactIdsToShopifyStoreRequest, endpoint: string) => Promise<AddUserRedactIdsToShopifyStoreResponse>, req: AddUserRedactIdsToShopifyStoreRequest): { promise: () => Promise<AddUserRedactIdsToShopifyStoreResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AddUserRedactIdsToShopifyStoreEndpoint),
      endpoint: AddUserRedactIdsToShopifyStoreEndpoint
    };
  }

  export const EmptyUserRedactIdsEndpoint = "/grpc/emissary.Shopify/EmptyUserRedactIds";
  export function EmptyUserRedactIds(sender: (req: EmptyUserRedactIdsRequest, endpoint: string) => Promise<EmptyUserRedactIdsResponse>, req: EmptyUserRedactIdsRequest): { promise: () => Promise<EmptyUserRedactIdsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, EmptyUserRedactIdsEndpoint),
      endpoint: EmptyUserRedactIdsEndpoint
    };
  }
}

export interface ShopifyStore {
  id: number;
  /** The org ID associated with the store. Used to tie a store to an org. */
  orgId: string;
  /**
   * This is sometimes referred to as the "shop name" in the Shopify API or store name. It is the domain of the store with the .myshopify.com suffix.
   * For example, "acme-store.myshopify.com". We use this as the primary identifier for the store.
   */
  domain: string;
  /**
   * Each store has a unique ID assigned by Shopify. So far we do not receive this from any of the integrations we have built but we do get it
   * from some of the webhook integrations.
   */
  shopifyId: string;
  /** The long-lived OAuth token for the store. This is used to make API calls to the store. (specifically for createWebhook) */
  token: string;
  /** The state value sent to Shopify during the OAuth flow. We use this to verify the redirect to prevent CSRF attacks. */
  nonce: string;
  /** Indicates whether the pixel extension has been installed from the ui via activate_pixel. */
  installed: boolean;
  createdAt: protobuf.timestamp | null;
  createdBy: string;
  updatedAt: protobuf.timestamp | null;
  updatedBy: string;
  /** The rec_host parameter for capture on the checkout pages. Defaults to "rs.fullstory.com" or "rs.eu1.fullstory.com" depending on the region. */
  recHost: string;
  /** The ID of the pixel we create for the store. This is used to update the pixel if needed. */
  pixelId: string;
  /** The segment ids with the users that need to be redacted. */
  segmentIds: string[];
  /** The user redact ids with the users that need to be redacted. */
  userRedactIds: string[];
  /** The cdn_host parameter for capture on the checkout pages. Defaults to "edge.fullstory.com" or "edge.eu1.fullstory.com" depending on the region. */
  cdnHost: string;
  /** Enable this option to track checkout_completed events as 'Ordered Completed' custom events. Defaults to false. */
  useOrderCompleted: boolean;
}

/** Request/Response messages for Shopify store operations */
export interface GetShopifyStoreRequest {
  orgId: string;
  domain: string;
}

export interface GetShopifyStoreResponse {
  store: ShopifyStore | null;
}

export interface GetShopifyStoresWithUserRedactIdsResponse {
  stores: ShopifyStore[];
}

export interface CreateShopifyStoreRequest {
  orgId: string;
  domain: string;
  shopifyId: string;
  token: string;
  nonce: string;
  installed: boolean;
  cdnHost: string;
  useOrderCompleted: boolean;
}

export interface CreateShopifyStoreResponse {
  store: ShopifyStore | null;
}

export interface UpdateShopifyStoreRequest {
  orgId: string;
  id: number;
  domain: string;
  shopifyId: string;
  token: string;
  nonce: string;
  installed: boolean;
  recHost: string;
  cdnHost: string;
  useOrderCompleted: boolean;
}

export interface UpdateShopifyStoreResponse {
  store: ShopifyStore | null;
}

export interface AddSegmentIdToShopifyStoreRequest {
  domain: string;
  segmentId: string;
}

export interface AddSegmentIdToShopifyStoreResponse {
  store: ShopifyStore | null;
}

export interface AddUserRedactIdsToShopifyStoreRequest {
  domain: string;
  userRedactIds: string[];
}

export interface AddUserRedactIdsToShopifyStoreResponse {
  store: ShopifyStore | null;
}

export interface EmptyUserRedactIdsRequest {
  domain: string;
  orgId: string;
}

export interface EmptyUserRedactIdsResponse {
  store: ShopifyStore | null;
}
